<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('yearlySaleItem.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('yearlySaleItem.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('yearlySaleItem.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('yearlySaleItem.year')
                          }}</label>
                          <ts-date-picker-input
                            format="YYYY"
                            v-model="model.year"
                          ></ts-date-picker-input>
                          <div class="validate" v-if="errors.has('year')">
                            {{ errors.first('year') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('yearlySaleItem.location')
                          }}</label>
                          <a-select
                            v-model="model.location_id"
                            :options="locations"
                            @change="fetchProduct"
                            class="ts-w-full"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('location_id')"
                          >
                            {{ errors.first('location_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('yearlySaleItem.product') }}</label>
                          <treeselect
                            :options="products"
                            placeholder="All"
                            :multiple="true"
                            :limit="1"
                            v-model="model.product_id"
                            openDirection="top"
                            :maxHeight="200"
                          ></treeselect>
                          <div class="validate" v-if="errors.has('product_id')">
                            {{ errors.first('product_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                   <div class="row">
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          outline
                          color="success"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="fas fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('yearlySaleItem.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'yearlySaleItem',
  data () {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      locations: [],
      branches: [],
      products: [],
      src: '',
      model: {
        year: moment().format('YYYY'),
        location_id: null,
        product_id: []
      }
    }
  },
  created () {
    this.fetchLocation()
  },
  methods: {
    ...mapActions('report/resource', ['getLocation', 'getProduct']),
    moment,
    async fetchLocation () {
      this.loading = true
      await this.getLocation()
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchProduct (location_id) {
      this.loading = true
      this.products = []
      this.model.product_id = []
      this.getProduct({
        filter: {
          location_id: location_id
        }
      })
        .then(response => {
          this.products = response.data.map(el => ({
            id: el.product.product_id,
            label: el.product.product_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview () {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/inventory/yearlySaleItem', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/inventory/yearlySaleItemExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
  }
}
</script>
